(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["giesto-catalog-presentation"] && !Shopify.designMode) return;
  try {
    class GiestoStoreCollection extends HTMLElement {
    // Kept as a static so the identifier cannot collide with another section's
    // script block - Shopify concatenates them all into one file.
    static VIEW_STORAGE_KEY = 'giesto:collection-view';
    static viewState = null;
    static DRAWER_ID = 'filters-drawer';
    static descriptionCache = new Map();

    // How much of the chip straddling the right edge stays in view, and the
    // band around it that is close enough to leave the row untouched.
    static CHIP_PEEK = 0.3;
    static CHIP_PEEK_MIN = 0.22;
    static CHIP_PEEK_MAX = 0.4;
    // How far the gap and the chip padding may travel from their design values
    // to reach that share. Measured across 320-900px, the gap stays inside 5-13
    // on every phone width and only reaches the bound at 320.
    static CHIP_GAP_ROOM = 8;
    static CHIP_PAD_ROOM = 4;

    #controller = null;
    #drawerObserver = null;
    #observedDrawer = null;
    #relabelQueued = false;
    #descriptionSyncQueued = false;
    #chipPeekQueued = false;
    #descriptionFull = null;
    #descriptionMeasure = null;
    #viewValue = '4';

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.addEventListener('change', this.#onChange, { signal });
      this.addEventListener('click', this.#onClick, { signal });
      document.addEventListener('click', this.#onDocumentClick, { signal });
      document.addEventListener('keydown', this.#onKeydown, { signal });

      // theme-drawer.js fires this on the <theme-drawer> element and it bubbles,
      // same contract giesto-header.liquid listens on for the cart drawer.
      document.addEventListener('theme-drawer:open', this.#onDrawerOpen, { signal });
      document.addEventListener('theme-drawer:close', this.#onDrawerClose, { signal });

      // Shopify's standard search bus — StandardEvents.searchUpdate. Fires when
      // a facet is applied, which is also when the section is re-rendered.
      document.addEventListener('shopify:search:update', this.#queueRelabel, { signal });

      // Whether two lines is short enough to hide anything depends on the
      // column width, so the measurement is redone whenever that can change.
      window.addEventListener('resize', this.#queueDescriptionSync, { signal });
      if (document.body.dataset.collectionSource) {
        document.addEventListener('giesto:ss26-catalog-updated', this.#queueDescriptionSync, { signal });
      }
      window.addEventListener('resize', this.#queueChipPeek, { signal });
      window.addEventListener('resize', this.#positionView, { signal });
      matchMedia('(max-width: 1024px)').addEventListener('change', () => {
        this.#syncArketView(this.#viewValue);
        this.#positionView();
      }, { signal });
      window.addEventListener('scroll', this.#positionView, { signal, passive: true });
      this.addEventListener('close', this.#onViewClose, { signal, capture: true });
      this.#queueDescriptionSync();
      this.#queueChipPeek();

      // Chip widths are set by the shop's own face, so a row measured before it
      // arrives is measured against the fallback and lands on the wrong chip.
      document.fonts?.addEventListener('loadingdone', this.#queueDescriptionSync, { signal });
      document.fonts?.ready.then(this.#queueChipPeek);
      document.fonts?.ready.then(() => { if (this.isConnected) this.#queueDescriptionSync(); });

      this.#restoreView();

      // If this element upgrades while the parser is still ahead of the drawer
      // markup, querySelector finds nothing — wait for the document instead.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.#queueRelabel, { once: true, signal });
        document.addEventListener('DOMContentLoaded', this.#queueDescriptionSync, { once: true, signal });
        document.addEventListener('DOMContentLoaded', this.#queueChipPeek, { once: true, signal });
      } else {
        this.#relabelDrawer();
        this.#observeDrawer();
      }
    }

    disconnectedCallback() {
      this.#closeView();
      this.#drawerObserver?.disconnect();
      this.#drawerObserver = null;
      this.#observedDrawer = null;
      this.#controller?.abort();
      this.#controller = null;
    }

    /* ---------- Collection description ---------- */

    #toggleDescription(button) {
      const description = button.closest('[data-gac-description]');
      if (!(description instanceof HTMLElement)) return;

      const expanded = description.dataset.expanded !== 'true';

      description.dataset.expanded = String(expanded);
      button.setAttribute('aria-expanded', String(expanded));

      const label = button.querySelector('[data-gac-description-label]');
      const text = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      if (label && text) label.textContent = text;

      // Re-measures on the way back down; on the way up it just restores the
      // full text.
      this.#syncDescription();
    }

    /**
     * Shortens the description until the text AND the control fit in two lines,
     * so the control ends up immediately after the last word. CSS cannot do
     * this: a clamped box reports nothing about where its text stopped.
     */
    #syncDescription = () => {
      const description = this.querySelector('[data-gac-description]');
      if (!(description instanceof HTMLElement)) return;
      if (document.fonts?.status === 'loading') { document.fonts.ready.then(() => { if (this.isConnected) this.#queueDescriptionSync(); }); return; }
      const body = description.querySelector('.gac__description-body');
      const text = description.querySelector('[data-gac-description-text]');
      if (!(body instanceof HTMLElement) || !(text instanceof HTMLElement)) return;
      if (this.#descriptionFull === null) this.#descriptionFull = text.textContent ?? '';
      const full = this.#descriptionFull;
      if (description.dataset.expanded === 'true') {
        if (text.textContent !== full) text.textContent = full;
        description.dataset.mode = 'js';
        this.#descriptionMeasure = null;
        return;
      }
      const width = description.getBoundingClientRect().width;
      if (!width) return;
      const style = getComputedStyle(body);
      const control = getComputedStyle(description.querySelector('[data-gac-description-toggle]'));
      const key = `${width}|${style.font}|${style.lineHeight}|${style.letterSpacing}|${control.font}|${control.letterSpacing}|${description.querySelector('[data-gac-description-label]')?.textContent}|${full}`;
      if (this.#descriptionMeasure === key && description.dataset.mode === 'js') return;
      const cached = GiestoStoreCollection.descriptionCache.get(key);
      if (cached) {
        text.textContent = cached.clipped; description.dataset.mode = 'js'; description.dataset.clamped = String(cached.clamped); this.#descriptionMeasure = key; return;
      }
      const maxHeight = (parseFloat(style.lineHeight) || 22) * 2 + 1;
      // Measuring ten prefixes in the live document forced ten full catalogue
      // layouts. A fixed, contained clone measures the same type/control in
      // isolation; the visible description receives only the final result.
      const measure = description.cloneNode(true);
      measure.setAttribute('aria-hidden', 'true');
      Object.assign(measure.style, { position: 'fixed', left: '-10000px', top: '0', width: `${width}px`, visibility: 'hidden', pointerEvents: 'none', contain: 'layout style paint' });
      measure.dataset.mode = 'js';
      measure.dataset.clamped = 'false';
      const measureBody = measure.querySelector('.gac__description-body');
      const measureText = measure.querySelector('[data-gac-description-text]');
      measureText.textContent = full;
      this.append(measure);
      let clipped = full;
      let clamped = false;
      try {
        if (measureBody.offsetHeight > maxHeight) {
          clamped = true;
          measure.dataset.clamped = 'true';
          // Lay out the complete text once. Range reads keep that layout
          // intact, unlike writing a new prefix at every binary-search step.
          const range = document.createRange();
          const node = measureText.firstChild;
          range.setStart(node, 0);
          range.setEnd(node, full.length);
          const firstRect = range.getClientRects()[0];
          const bodyRect = measureBody.getBoundingClientRect();
          const controlWidth = measure.querySelector('.gac__description-more').getBoundingClientRect().width;
          let low = 0, high = full.length, fits = 0;
          while (low <= high) {
            const middle = (low + high) >> 1;
            range.setEnd(node, middle);
            const rects = range.getClientRects();
            const last = rects[rects.length - 1];
            const withinLines = !last || last.top < firstRect.top + (parseFloat(style.lineHeight) || 22) + 1;
            const roomForControl = !last || last.top < firstRect.top + 1 || last.right + controlWidth <= bodyRect.right + .5;
            if (withinLines && roomForControl) { fits = middle; low = middle + 1; }
            else high = middle - 1;
          }
          range.detach();
          clipped = full.slice(0, fits);
          const lastSpace = clipped.lastIndexOf(' ');
          if (lastSpace > 0) clipped = clipped.slice(0, lastSpace);
          clipped = clipped.replace(/[\s.,;:!?-]+$/u, '');
          measureText.textContent = clipped;
          for (let guard = 0; guard < 2 && measureBody.offsetHeight > maxHeight; guard++) {
            clipped = clipped.slice(0, Math.max(0, clipped.lastIndexOf(' '))).replace(/[\s.,;:!?-]+$/u, '');
            measureText.textContent = clipped;
          }
        }
      } finally { measure.remove(); }
      if (text.textContent !== clipped) text.textContent = clipped;
      description.dataset.mode = 'js';
      description.dataset.clamped = String(clamped);
      this.#descriptionMeasure = key;
      GiestoStoreCollection.descriptionCache.set(key, { clipped, clamped });
      while (GiestoStoreCollection.descriptionCache.size > 32) GiestoStoreCollection.descriptionCache.delete(GiestoStoreCollection.descriptionCache.keys().next().value);
    };

    #queueDescriptionSync = () => {
      if (this.#descriptionSyncQueued) return;
      this.#descriptionSyncQueued = true;

      requestAnimationFrame(() => {
        this.#descriptionSyncQueued = false;
        this.#syncDescription();
      });
    };

    /* ---------- Chip row peek ---------- */

    #queueChipPeek = () => {
      if (this.#chipPeekQueued) return;
      this.#chipPeekQueued = true;

      requestAnimationFrame(() => {
        this.#chipPeekQueued = false;
        this.#tuneChipPeek();
      });
    };

    /**
     * Below the wrap breakpoint a chip row is a horizontal scroller, and where
     * it happens to end flush with the screen edge it reads as the whole list —
     * nothing tells a shopper the rest of the categories are one swipe away.
     * Whether that happens is down to the viewport width against the sum of the
     * chip widths, so it cannot be pinned in CSS at every resolution.
     *
     * This leaves the chip that crosses the edge about a third in view. The
     * shift rides on the gaps and the chips' own side padding rather than on
     * the row's leading padding, so the first chip stays on the same gutter as
     * the title above it and the row reads as slightly roomier rather than
     * visibly gappy — splitting it across two dimensions halves how far either
     * has to move. It only runs on a scroller that is not already cut at a
     * readable share, so most widths are left exactly as designed.
     */
    #tuneChipPeek = () => {
      const { CHIP_PEEK, CHIP_PEEK_MIN, CHIP_PEEK_MAX, CHIP_GAP_ROOM, CHIP_PAD_ROOM } = GiestoStoreCollection;

      for (const list of this.querySelectorAll('.gac__chips-list')) {
        // Only the first view is tuned. A shopper who has already swiped can
        // see the rest of the row for themselves, and re-spacing it under their
        // finger — which a morph after a filter would do — is worse than an
        // edge that happens to fall flush.
        if (list.scrollLeft > 1) continue;

        // Measure against the design values, never against a previous tuning.
        list.style.removeProperty('--gac-chips-gap');
        list.style.removeProperty('--gac-chip-pad');

        const styles = getComputedStyle(list);
        // Wrapped rows hold every chip already: there is nothing behind an edge.
        if (styles.flexWrap === 'wrap') continue;

        const items = [...list.children];
        if (items.length < 2) continue;

        // The right edge of the row as it first appears, in content
        // coordinates — the shopper has not scrolled yet.
        const edge = list.clientWidth;
        const listLeft = list.getBoundingClientRect().left;
        const bounds = items.map((item) => {
          const rect = item.getBoundingClientRect();
          const start = rect.left - listLeft + list.scrollLeft;
          return { start, end: start + rect.width, width: rect.width };
        });

        // Every chip fits: there is nothing to swipe to, so nothing to hint at.
        if (bounds[bounds.length - 1].end <= edge + 1) continue;

        const index = bounds.findIndex((item) => item.end > edge);
        // A first chip wider than the screen has no gap in front of it to move.
        if (index < 1) continue;

        const chip = bounds[index];
        const visible = (edge - chip.start) / chip.width;
        if (visible >= CHIP_PEEK_MIN && visible <= CHIP_PEEK_MAX) continue;

        const pill = list.querySelector('.gac__chip');
        if (!pill) continue;

        // Everything ahead of the chip carries an equal share of the shift:
        // each of the `index` gaps one step, each of the `index` chips before it
        // two half-steps of side padding. That is 2 * index steps in all.
        const gap = parseFloat(styles.columnGap) || 0;
        const pad = parseFloat(getComputedStyle(pill).paddingLeft) || 0;
        const step = (edge - chip.width * CHIP_PEEK - chip.start) / (index * 2);

        // Bounded, so a row that would need a sparse gap to reach the third
        // comes out cut a little short of it instead.
        const tunedGap = Math.min(Math.max(gap + step, 4), gap + CHIP_GAP_ROOM);
        const tunedPad = Math.min(Math.max(pad + step / 2, 8), pad + CHIP_PAD_ROOM);
        if (Math.abs(tunedGap - gap) < 0.5 && Math.abs(tunedPad - pad) < 0.5) continue;

        list.style.setProperty('--gac-chips-gap', `${tunedGap.toFixed(2)}px`);
        list.style.setProperty('--gac-chip-pad', `${tunedPad.toFixed(2)}px`);
      }
    };

    /* ---------- Filter drawer copy ---------- */

    #getDrawer() {
      return (
        this.querySelector(`#${GiestoStoreCollection.DRAWER_ID}`) ??
        document.getElementById(GiestoStoreCollection.DRAWER_ID)
      );
    }

    // Rewrites only text nodes. The count badge, its visually-hidden sibling and
    // every other node in the drawer are left exactly as the theme rendered them.
    // Writes happen only when the text actually differs, so re-entering through
    // the MutationObserver settles after one pass instead of looping.
    #relabelDrawer() {
      const drawer = this.#getDrawer();
      if (!drawer) return;

      const title = this.dataset.filterDrawerTitle;
      const heading = drawer.querySelector('.theme-drawer__title');
      if (title && heading) {
        for (const node of heading.childNodes) {
          if (node.nodeType !== Node.TEXT_NODE) continue;
          if (!node.nodeValue?.trim()) continue;
          // Trailing space preserved: it is the only gap between the heading
          // and the filter-count badge that follows it.
          if (node.nodeValue.trim() !== title) node.nodeValue = `${title} `;
          break;
        }
      }

      const applyLabel = this.dataset.filterApplyLabel;
      const applyButton = drawer.querySelector('.facets__see-results');
      if (applyLabel && applyButton) {
        const themeLabel = applyButton.textContent?.trim();
        if (themeLabel && themeLabel !== applyLabel) {
          // The theme's label carries the result count, which is the whole point
          // of that button. Keep it in the accessible name, prefixed with the
          // visible word so the name still contains the visible label.
          applyButton.setAttribute('aria-label', `${applyLabel}, ${themeLabel}`);
          applyButton.textContent = applyLabel;
        }
      }
    }

    // The drawer node survives a morph (data-skip-node-update keeps the element
    // itself, but morph still recurses into its children and restores the
    // theme's text), so re-binding is only needed if the node identity changes.
    #observeDrawer() {
      const drawer = this.#getDrawer();
      if (!drawer) return;
      if (this.#observedDrawer === drawer && this.#drawerObserver) return;

      this.#drawerObserver?.disconnect();
      this.#observedDrawer = drawer;
      this.#drawerObserver = new MutationObserver(this.#queueRelabel);
      this.#drawerObserver.observe(drawer, { childList: true, characterData: true, subtree: true });
    }

    // A morph touches many nodes at once; coalesce them into one relabel.
    #queueRelabel = () => {
      if (this.#relabelQueued) return;
      this.#relabelQueued = true;
      requestAnimationFrame(() => {
        this.#relabelQueued = false;
        this.#relabelDrawer();
        this.#observeDrawer();
        this.#syncArketView(this.#viewValue);
        // A morph can add, drop or re-label chips, which moves the edge.
        this.#tuneChipPeek();
      });
    };

    #onDrawerOpen = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      this.#setDrawerTriggerState(target.id, true);
      if (target.id === GiestoStoreCollection.DRAWER_ID) {
        target.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
        const scroller = target.querySelector('.facets-drawer__filters');
        if (scroller) scroller.scrollTop = 0;
        this.#relabelDrawer();
        this.#observeDrawer();
      }
    };

    #onDrawerClose = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      this.#setDrawerTriggerState(target.id, false);
    };

    #setDrawerTriggerState(drawerId, open) {
      if (!drawerId) return;
      const trigger = this.querySelector(`[data-gac-drawer-trigger="${CSS.escape(drawerId)}"]`);
      if (trigger) trigger.setAttribute('aria-expanded', String(open));
    };

    // Declarative `on:click` actions intentionally only upgrade custom elements
    // ending in `-component`. A <theme-drawer> may therefore still be a plain
    // element on a slow Theme Editor preview when the shopper clicks it. Keep
    // this recovery local to the ARKET collection controls instead of changing
    // the theme-wide action dispatcher.
    #requestDrawerAction(drawerId, action) {
      const drawer = this.querySelector(`#${CSS.escape(drawerId)}`) ?? document.getElementById(drawerId);
      if (!(drawer instanceof HTMLElement)) return;

      const invoke = () => {
        if (!drawer.isConnected) return false;

        try {
          customElements.upgrade(drawer);
        } catch {
          // A not-yet-defined custom element is retried below.
        }

        const method = drawer[action];
        if (typeof method !== 'function') return false;
        method.call(drawer);
        return true;
      };

      if (invoke()) return;

      if (action === 'close') {
        // If the module is still loading, do not leave a visible native dialog
        // trapping the preview. The upgraded drawer will see the cleared state
        // once it finishes loading.
        const panel = drawer.querySelector('dialog');
        if (panel instanceof HTMLDialogElement && panel.open) panel.close();
        drawer.removeAttribute('open');
        this.#setDrawerTriggerState(drawerId, false);
      }

      customElements.whenDefined('theme-drawer').then(() => {
        invoke();
      });
    };

    // Retain same-collection choices through filtering and sort navigation.
    // A new collection or explicit reload uses its editorial/grid default.
    #restoreView() {
      let state = GiestoStoreCollection.viewState;
      if (!state && performance.getEntriesByType('navigation')[0]?.type !== 'reload') {
        try { state = JSON.parse(sessionStorage.getItem(GiestoStoreCollection.VIEW_STORAGE_KEY)); } catch {}
      }
      const value = state?.path === location.pathname ? state.value : this.hasAttribute('data-gac-story-enabled') && this.dataset.gnrLayout === 'editorial' ? 'stories' : '4';
      this.#syncArketView(value);
    }

    #closeView() {
      const panel = this.querySelector('[data-gac-view-panel]');
      if (panel?.open) panel.close();
      this.querySelector('[data-gac-view-trigger]')?.setAttribute('aria-expanded', 'false');
    }

    #onViewClose = event => {
      if (event.target.matches('[data-gac-view-panel]')) this.#closeView();
    };

    #positionView = () => {
      const panel = this.querySelector('[data-gac-view-panel]');
      if (!panel?.open) return;
      const trigger = this.querySelector('[data-gac-view-trigger]');
      if (!trigger?.getClientRects().length) { this.#closeView(); return; }
      const anchor = trigger.getBoundingClientRect();
      const box = panel.getBoundingClientRect();
      // The reference panel aligns 16px from the viewport edge.
      panel.style.left = Math.max(16, innerWidth - box.width - 16) + 'px';
      panel.style.top = Math.max(16, Math.min(anchor.bottom + 8, innerHeight - box.height - 16)) + 'px';
    };

    #syncArketView(value) {
      if (this.hasAttribute('data-gac-grid-only') || this.dataset.gacStoryFailed === 'true') value = '4';
      const compact = this.hasAttribute('data-gac-story-enabled') && matchMedia('(max-width: 1024px)').matches;
      if (compact && value === '3') value = '4';
      this.#viewValue = value === 'stories' && this.hasAttribute('data-gac-story-enabled') ? 'stories' : value === '3' ? '3' : '4';
      document.body.dataset.gaView = this.#viewValue;
      this.dataset.gacView = this.#viewValue;
      const stories = this.querySelector('giesto-collection-stories');
      if (stories) {
        stories.hidden = this.#viewValue !== 'stories';
        if (!stories.hidden) stories.activate?.();
      }
      GiestoStoreCollection.viewState = {path: location.pathname, value: this.#viewValue};
      try { sessionStorage.setItem(GiestoStoreCollection.VIEW_STORAGE_KEY, JSON.stringify(GiestoStoreCollection.viewState)); } catch {}
      for (const option of this.querySelectorAll('[data-gac-view-option]')) {
        option.disabled = compact && option.value === '3';
        option.checked = option.value === this.#viewValue;
      }
      const occupied = new Set();
      let cursor = 0;
      // A 2×2 feature only remains in the three-column view if it fits at
      // the next product position, matching the reference's packing rule.
      for (const cell of this.querySelectorAll('.gac__cell')) {
        while (occupied.has(cursor)) cursor++;
        const slots = [cursor, cursor + 1, cursor + 3, cursor + 4];
        const big = cell.classList.contains('gac__cell--feature') && cursor % 3 < 2 && slots.every(slot => !occupied.has(slot));
        cell.classList.toggle('ga-alt-feature', big);
        for (const slot of big ? slots : [cursor]) occupied.add(slot);
        cursor++;
      }
    }

    #onChange = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (target.matches('[data-gac-sort], [data-gac-sort-option]')) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', /** @type {HTMLSelectElement} */ (target).value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
        return;
      }

      if (target.matches('[data-gac-view-option]')) {
        this.#closeView();
        this.#syncArketView(/** @type {HTMLInputElement} */ (target).value);
      }
    };

    /**
     * Mirrors a chip click onto the product type checkboxes right away. The
     * group is single-select, so a chip clears every other box in it — the same
     * rule facets.js applies when the box itself is the control. The re-render
     * morphs them to the server's state a moment later; this only covers the
     * gap, so a shopper who opens the drawer while the request is still in
     * flight never sees the box disagree with the chip.
     * @param {HTMLAnchorElement} chip
     */
    #syncTypeInputs(chip) {
      const param = this.dataset.gacTypeFilterParam;
      if (!param) return;

      const value = chip.dataset.gacTypeValue;
      for (const input of this.querySelectorAll('input[type="checkbox"]')) {
        if (!(input instanceof HTMLInputElement) || input.name !== param) continue;

        // The "view all" chip carries no value: it clears the whole group.
        // Every other chip keeps only its own box — an active chip is the
        // removal link, so clicking it clears that one too and means "any".
        input.checked = Boolean(value) && input.value === value && !chip.classList.contains('is-active');
      }
    }

    #onClick = (event) => {
      // Element, not HTMLElement — clicks landing on an inline <svg> or <path>
      // are SVGElement, and an HTMLElement check would swallow them.
      const target = event.target;
      if (!(target instanceof Element)) return;

      const descriptionToggle = target.closest('[data-gac-description-toggle]');
      if (descriptionToggle instanceof HTMLButtonElement && this.contains(descriptionToggle)) {
        this.#toggleDescription(descriptionToggle);
        return;
      }

      const tagChip = target.closest('[data-gac-tag-chip]');
      if (tagChip instanceof HTMLAnchorElement && this.contains(tagChip)) {
        const tagFilterParam = this.dataset.gacTagFilterParam;

        // Without Shopify's Product tag storefront filter, the rendered link
        // remains a complete legacy-tag URL. With it enabled, keep the modern
        // facet flow so sort and every other selected filter survive the
        // category switch, while the tag itself stays mutually exclusive.
        if (!tagFilterParam) return;

        event.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.delete(tagFilterParam);

        const tagValue = tagChip.dataset.gacTagValue;
        if (tagValue) url.searchParams.set(tagFilterParam, tagValue);
        url.searchParams.delete('page');

        const facetsForm = this.querySelector('facets-form-component');
        if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
          facetsForm.updateFiltersByURL(url.toString());
        } else {
          window.location.assign(url.toString());
        }
        return;
      }

      // Product type chips. The group is single-select, so the href is the
      // group's removal URL with this one type appended — exactly the URL the
      // matching checkbox in the filter drawer now submits, because clearing
      // its siblings is what facets.js does there. Both controls resolve to one
      // URL state and neither can drift from the other. Applying it through the
      // facets form re-renders the section, which is also what repaints the
      // drawer's checkboxes and the active chip.
      const typeChip = target.closest('[data-gac-type-chip]');
      if (typeChip instanceof HTMLAnchorElement && this.contains(typeChip)) {
        const facetsForm = this.querySelector('facets-form-component');

        // Filters hidden, or facets.js not loaded yet: let the link navigate.
        // The same URL filters server-side, just with a full page load.
        if (!facetsForm || typeof facetsForm.updateFiltersByURL !== 'function') return;

        event.preventDefault();
        this.#syncTypeInputs(typeChip);

        // Pagination belongs to the result set being left behind: carried over,
        // a switch to a category with fewer pages lands on an empty grid.
        const typeUrl = new URL(typeChip.href);
        typeUrl.searchParams.delete('page');
        facetsForm.updateFiltersByURL(typeUrl.toString());
        return;
      }

      const drawerTrigger = target.closest('[data-gac-drawer-open]');
      if (drawerTrigger instanceof HTMLElement && this.contains(drawerTrigger)) {
        const drawerId = drawerTrigger.dataset.gacDrawerOpen;
        if (drawerId) this.#requestDrawerAction(drawerId, 'open');
        return;
      }

      const drawerClose = target.closest('[data-gac-drawer-close]');
      if (drawerClose instanceof HTMLElement && this.contains(drawerClose)) {
        const drawerId = drawerClose.dataset.gacDrawerClose;
        if (drawerId) this.#requestDrawerAction(drawerId, 'close');
        return;
      }

      // Clicking the already-selected radio does not emit change.
      if (target.matches('[data-gac-view-option]')) this.#closeView();

      const viewTrigger = target.closest('[data-gac-view-trigger]');
      if (viewTrigger) {
        const panel = this.querySelector('[data-gac-view-panel]');
        if (!(panel instanceof HTMLDialogElement)) return;
        if (panel.open) this.#closeView();
        else {
          panel.showModal();
          this.querySelector('giesto-collection-stories')?.prefetch?.();
          viewTrigger.setAttribute('aria-expanded', 'true');
          this.#positionView();
        }
        return;
      }

      // The gallery arrows are handled by assets/giesto-store-card.js, delegated
      // from the document, so every section that renders the card gets them.
      // This element used to own that logic, which left the arrows dead on any
      // page without it — the sale page, for one.
    };



    #onDocumentClick = (event) => {
      const panel = this.querySelector('[data-gac-view-panel]');
      if (!panel?.open || event.target !== panel) return;
      const box = panel.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.#closeView();
    };

    #onKeydown = (event) => {
      if (event.key !== 'Escape' || !this.querySelector('[data-gac-view-panel]')?.open) return;
      event.preventDefault();
      this.#closeView();
    };

  }

  if (!customElements.get('giesto-store-collection')) {
    customElements.define('giesto-store-collection', GiestoStoreCollection);
  }
  } catch(e) { console.error(e); }
})();

})();
